import { UPDATE_WAREHOUSES, WarehouseActions } from '../../actions/warehouseEmployee/warehouseSelection/types';
import { WarehousesState } from './types';

export const initialState: WarehousesState = {
    availableWarehouses: [],
};

export default function warehousesReducer(
    // biome-ignore lint/style/useDefaultParameterLast: standard signature of reducer function
    state: WarehousesState = initialState,
    action: WarehouseActions,
): WarehousesState {
    switch (action.type) {
        case UPDATE_WAREHOUSES:
            return {
                ...state,
                availableWarehouses: action.payload,
            };
        default:
            return state;
    }
}
